import { MenuItem } from "../models/menu-item.model";
import { User } from "../models/users.model";

export const hasPermission = (menu: MenuItem, user: User) => {
    if (!menu?.abilities || !Array.isArray(menu.abilities)) return false; 
    if (!user?.my_permission || !Array.isArray(user.my_permission)) return false;
    return menu.abilities.some((ability: string) =>
        user.my_permission.includes(ability)
    );
}